// Analytics deferred — stub to no-op to unblock build
export async function logUserActivity(
  _action: string,
  _metadata: Record<string, any> = {}
): Promise<void> {
  // no-op until analytics are wired post-launch
}
